import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { LookupTableFields } from "components/lookup-tables";
const _LookupTableFieldValueProviderForm = class _LookupTableFieldValueProviderForm extends React.Component {
  constructor() {
    super(...arguments);
    this.propagateChanges = (key, value) => {
      const { config, onChange } = this.props;
      const nextProviders = cloneDeep(config.providers);
      const lookupProvider = nextProviders.find((provider) => provider.type === _LookupTableFieldValueProviderForm.type);
      lookupProvider[key] = value;
      onChange({ ...config, providers: nextProviders });
    };
    this.handleSelectChange = (key) => (nextLookupTable) => {
      this.propagateChanges(key, nextLookupTable);
    };
  }
  render() {
    const { config, validation } = this.props;
    const provider = config.providers.find((p) => p.type === _LookupTableFieldValueProviderForm.type);
    return /* @__PURE__ */ React.createElement(
      LookupTableFields,
      {
        onTableNameChange: this.handleSelectChange("table_name"),
        onKeyChange: this.handleSelectChange("key_field"),
        selectedTableName: provider.table_name,
        selectedKeyName: provider.key_field,
        nameValidation: validation.errors.table_name,
        keyValidation: validation.errors.key_field
      }
    );
  }
};
_LookupTableFieldValueProviderForm.type = "lookup-v1";
_LookupTableFieldValueProviderForm.defaultConfig = {
  table_name: "",
  key_field: ""
};
_LookupTableFieldValueProviderForm.requiredFields = ["table_name", "key_field"];
let LookupTableFieldValueProviderForm = _LookupTableFieldValueProviderForm;
export default LookupTableFieldValueProviderForm;
